import React from "react";
import { Checkbox, QuestionTooltip, TooltipProps } from "component-library";
import { ControlSection } from "../../../../../Common";
import { ITwinViewModel } from "../../../../models/views";

export interface ITwinContent {
  twinSectionName: string;
  haveTwinLabel: string;
  twinTooltip: TooltipProps;
}

interface ITwinProps {
  model: ITwinViewModel;
  content: ITwinContent;
  handleChanges: (model: ITwinViewModel) => void;
}

const Twin: React.FunctionComponent<React.PropsWithChildren<ITwinProps>> = (
  props: ITwinProps
) => {
  const { model, content } = props;

  const handleToggling = (value: boolean) => {
    const updatedModel = { ...props.model };

    updatedModel.haveTwin = value;

    props.handleChanges(updatedModel);
  };

  return (
    <ControlSection name={content.twinSectionName}>
      <div className="c-additional-info-form__twin">
        <div className="c-additional-info-form__control-grid-2">
          <Checkbox
            label={content.haveTwinLabel}
            ariaLabel={content.haveTwinLabel}
            checked={model.haveTwin}
            value=""
            name="have-twin"
            valueChanged={handleToggling}
            annex={
              content.twinTooltip && (
                <QuestionTooltip {...content.twinTooltip} />
              )
            }
          />
        </div>
      </div>
    </ControlSection>
  );
};

export default Twin;
